import React from 'react';
import { SignupComponent } from './components/index';

const Signup = () => {
	return <SignupComponent />;
};
export default Signup;
